import { GetStaticPathsResult, GetStaticPropsContext, GetStaticPropsResult } from 'next';
import invariant from 'tiny-invariant';

import { getBlogAuthorbyFBID } from '../../src/api/contentful/blog/getBlogAuthorByFBID';
import { getRutilusGraphqlClient } from '../../src/api/graphql/getRutilusGraphqlClient';
import { queryRutilusStatic } from '../../src/api/graphql/queryRutilusStatic';
import { NOT_FOUND_WITH_REVALIDATION, REVALIDATE } from '../../src/constants/next';
import { reportMykissError } from '../../src/helpers/errorHandling';
import { GetProfile, GetProfileVariables } from '../../src/interfaces/graphql';
import { IPageMetadata } from '../../src/interfaces/nextjs';
import { getProfile } from '../../src/queries/rutilus/Users';
import { Angler, IAnglerProps } from '../../src/views/Angler/Angler';

type IParams = {
  nickname: string;
};

export async function getStaticProps({
  params,
}: GetStaticPropsContext<IParams>): Promise<GetStaticPropsResult<IPageMetadata & IAnglerProps>> {
  invariant(params, 'Params not found');

  try {
    const client = getRutilusGraphqlClient({ serverMode: 'static' });

    const { response } = await queryRutilusStatic<GetProfile, GetProfileVariables>(client, {
      query: getProfile,
      variables: {
        nickname: params.nickname,
      },
    });

    if (response === undefined) {
      return NOT_FOUND_WITH_REVALIDATION;
    }
    const result = await getBlogAuthorbyFBID(params.nickname);
    return {
      props: {
        _page: 'user',
        _pageTitle: 'Angler',
        angler: response.data.user,
        blogSlug: result?.fields.slug || null,
      },
      revalidate: REVALIDATE.DAILY,
    };
  } catch (error) {
    reportMykissError(error);
    return NOT_FOUND_WITH_REVALIDATION;
  }
}

export async function getStaticPaths(): Promise<GetStaticPathsResult<IParams>> {
  return {
    paths: [],
    fallback: 'blocking',
  };
}

export default Angler;
